import type { Components } from '@/api/generated/api';
import { useAsyncOperations } from '@/composables/useAsyncOperations';
import { assertNotNullOrUndefined } from '@/utils/assertion.utils';
import type { IPdfExportResult } from 'common/interface/pdf-export.interface';

type TStartPdfExport = () => Promise<Components.Schemas.AsyncOperationCreatedResponseDto>;

/** Runs a backend PDF export job to its end; callers show their own loading state and error toast. */
export const usePdfExportOperation = (): { runPdfExport: (start: TStartPdfExport) => Promise<IPdfExportResult> } => {
  const { startAsyncOperation } = useAsyncOperations();

  const runPdfExport = async (start: TStartPdfExport): Promise<IPdfExportResult> => {
    const startedOperation = await startAsyncOperation<IPdfExportResult>({
      start,
      shouldBlockFrontend: true,
      hideToast: true,
      onCompleted: ({ status }) => {
        const result = status.result as IPdfExportResult | null;
        assertNotNullOrUndefined(result);
        return result;
      },
    });
    const result = await startedOperation.finished;
    assertNotNullOrUndefined(result);
    return result;
  };

  return { runPdfExport };
};
